/* Karban compare — original overhaul design, OUR catalog data.
   Desktop: 4 columns. Mobile: 2 columns chosen via dropdown switchers. */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var P = window.PRODUCTS || [];
    function byId(id){ for(var i=0;i<P.length;i++) if(P[i].id===id) return P[i]; return {name:id,price:'',white:'',href:'#'}; }
    /* original column order: Smart · Pure · Smart Plus · Pure Plus */
    var COLS = ['airzone-smart','airzone-pure','airzone-smart-plus','airzone-pure-plus'].map(byId);

    /* OUR catalog data, in the column order above */
    var GROUPS = [
      { group:'The essentials', rows:[
        { label:'HEPA air purifier',         vals:[false, true, false, true] },
        { label:'Bladeless air circulator',  vals:[true, true, true, true] },
        { label:'Colour-changing light',     vals:[true, true, true, true] },
        { label:'Dual Zone Technology',      vals:[false, false, true, true] },
      ]},
      { group:'Coverage & power', rows:[
        { label:'Recommended space',  vals:['Standard rooms','Standard rooms','Medium–large','Medium–large'] },
        { label:'Purification coverage', vals:['—','400 sq ft','—','800 sq ft'] },
        { label:'Max power',          vals:['68 W','68 W','136 W','136 W'] },
      ]},
      { group:'Air purification', rows:[
        { label:'HEPA filter grade',  vals:['—','H11','—','H11'] },
        { label:'CADR',               vals:['—','250 m³/h','—','500 m³/h'] },
        { label:'Filter efficiency',  vals:['—','99.5%','—','99.5%'] },
        { label:'Live AQI (product + app)', vals:[false, true, false, true] },
      ]},
      { group:'Air circulation', rows:[
        { label:'Motor',              vals:['BLDC+','BLDC+','BLDC+','BLDC+'] },
        { label:'Air circulation',    vals:['4,400 CMH','3,900 CMH','8,800 CMH','7,800 CMH'] },
        { label:'Airflow speed',      vals:['8–9 m/s','6–7 m/s','8–9 m/s','6–7 m/s'] },
      ]},
      { group:'Light', rows:[
        { label:'Light',              vals:['Colour-changing','Colour-changing','Colour-changing','Colour-changing'] },
        { label:'Brightness',         vals:['2,000 lm','2,000 lm','4,000 lm','4,000 lm'] },
        { label:'Dimmable',           vals:[true, true, true, true] },
      ]},
      { group:'Controls', rows:[
        { label:'Remote + app',       vals:[true, true, true, true] },
        { label:'Voice (Alexa / Google)', vals:[true, true, true, true] },
      ]},
      { group:'Build & care', rows:[
        { label:'Finish',             vals:['Black / White','Black / White','Black / White','Black / White'] },
        { label:'Installation',       vals:['Ceiling / floor','Ceiling / floor','Ceiling only','Ceiling only'] },
        { label:'Certification',      vals:['BIS','BIS','BIS','BIS'] },
        { label:'Warranty',           vals:['1 year','1 year','1 year','1 year'] },
      ]},
    ];

    var onlyDiff=false, mobSel=[0,3], active=[0,1,2,3], labW='210px';
    function isMobile(){ return window.matchMedia('(max-width:860px)').matches; }
    function check(){ return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4 10-10"/></svg>'; }
    function cellHTML(v){ if(v===true) return check(); if(v===false||v==='—') return '<span class="cmp-dash">—</span>'; return v; }
    function differs(vals){ var s={}; vals.forEach(function(v){s[String(v)]=1;}); return Object.keys(s).length>1; }
    function gc(){ return labW+' repeat('+active.length+', 1fr)'; }

    function render(){
      var mobile=isMobile();
      active = mobile ? mobSel.slice() : [0,1,2,3];
      labW = mobile ? '108px' : '210px';
      var g=gc();
      var head=document.getElementById('cmpHead');
      head.style.gridTemplateColumns=g;
      /* spacer must be NON-empty: Dawn base.css has div:empty{display:none},
         which eats an empty spacer and shifts every column one track left */
      head.innerHTML='<div aria-hidden="true">&nbsp;</div>'+active.map(function(i){ var p=COLS[i];
        return '<div class="cmp-col"><img src="'+p.white+'" alt="'+p.name+'"><span class="nm">'+p.name+'</span><span class="pr">From '+p.price+'</span></div>'; }).join('');

      var html='';
      GROUPS.forEach(function(grp){
        var rows=grp.rows.filter(function(r){ return !onlyDiff || differs(active.map(function(i){return r.vals[i];})); });
        if(!rows.length) return;
        html+='<div class="cmp-group"><h2>'+grp.group+'</h2>';
        rows.forEach(function(r){
          html+='<div class="cmp-row" style="grid-template-columns:'+g+'"><div class="cmp-lab">'+r.label+'</div>'+
            active.map(function(i){ return '<div class="cmp-cell">'+cellHTML(r.vals[i])+'</div>'; }).join('')+'</div>';
        });
        html+='</div>';
      });
      /* pricing */
      html+='<div class="cmp-group"><h2>Pricing</h2>'+
        '<div class="cmp-row" style="grid-template-columns:'+g+'"><div class="cmp-lab">Starting price</div>'+
        active.map(function(i){ return '<div class="cmp-cell"><span class="cmp-price-val">'+COLS[i].price+'</span></div>'; }).join('')+'</div>'+
        '<div class="cmp-row" style="grid-template-columns:'+g+'"><div class="cmp-lab">&nbsp;</div>'+
        active.map(function(i){ return '<div class="cmp-cell"><a class="btn btn-primary btn-sm" href="'+COLS[i].href+'">Shop</a></div>'; }).join('')+'</div></div>';
      document.getElementById('cmpBody').innerHTML=html;
    }

    var tog=document.getElementById('cmpToggle');
    if(tog) tog.addEventListener('click',function(){ onlyDiff=!onlyDiff; tog.classList.toggle('on',onlyDiff); render(); });
    var a=document.getElementById('selA'), b=document.getElementById('selB');
    if(a&&b){
      var opts=COLS.map(function(p,i){return '<option value="'+i+'">'+p.name+'</option>';}).join('');
      a.innerHTML=opts; b.innerHTML=opts; a.value=mobSel[0]; b.value=mobSel[1];
      a.onchange=function(){ mobSel[0]=+a.value; render(); };
      b.onchange=function(){ mobSel[1]=+b.value; render(); };
    }
    render();
    var was=isMobile();
    window.addEventListener('resize',function(){ var m=isMobile(); if(m!==was){ was=m; render(); } });
  });
})();
